import React from 'react';
import { useIntl } from 'react-intl';
import Util from '../../../../shared/util/util.js';
import styled, { css } from 'styled-components';
const TimesheetTotalsStyle = styled.div `
	display: flex;
	flex-direction: column;
	gap: 4px;
	flex-grow: 1;
	justify-content: center;
`;
const TimesheetTotalsText = styled.span `
	display: inline-block;
	width: fit-content;
	line-height: 14px;
	text-align: left;
	white-space: nowrap;
	cursor: pointer;

	${({ light }) => light &&
    css `
			color: #727483;
		`}

	&:hover {
		color: #650ed8;
	}
`;
function TimesheetsTimeTableTotals({ minutesRegistered, billableMinutesRegistered, workPeriodInMinutes, showBillable, dataCy, goToTimesheetsTab, }) {
    const intl = useIntl();
    const registeredTimeInHours = Util.convertMinutesToFullHour(minutesRegistered, intl, true);
    const billableRegisteredTimeInHours = Util.convertMinutesToFullHour(billableMinutesRegistered, intl, true);
    const workPeriodInHours = Util.convertMinutesToFullHour(workPeriodInMinutes, intl, true);
    return (React.createElement(TimesheetTotalsStyle, null, showBillable ? (React.createElement(React.Fragment, null,
        React.createElement(TimesheetTotalsText, { "data-cy": dataCy, onClick: () => goToTimesheetsTab() }, `Timesheet Total: ${registeredTimeInHours}/${workPeriodInHours}`),
        React.createElement(TimesheetTotalsText, { light: true, onClick: () => goToTimesheetsTab() }, `Billable Total: ${billableRegisteredTimeInHours}`))) : (React.createElement(TimesheetTotalsText, { "data-cy": dataCy, onClick: () => goToTimesheetsTab() }, `Timesheet Total: ${registeredTimeInHours}/${workPeriodInHours}`))));
}
export default TimesheetsTimeTableTotals;
